"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isMobile = function isMobile(e) {
  return /^1[1234567890]\d{9}$/.test(e);
};

var isEmail = function isEmail(e) {
  return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(e);
};

var isArea = function isArea(e) {
  return /^\d{6}$/.test(e);
};

var isNumber = function isNumber(e) {
  return /^(([1-9]\d*)|(([0]\.\d{1,2}|[1-9]\d*\.\d{1,2})))$/.test(e);
};

var isBLen = function isBLen(value, options) {
  if (value === null || value === undefined) {
    value = '';
  }

  options = options || {};
  var defaults = {
    min: false,
    max: false
  };
  options = Object.assign({}, defaults, options);

  if (typeof value !== 'string') {
    return false;
  }

  var len = value.replace(/[^\u0000-\u00ff]/g, '01').length;

  if (options.min && len < options.min * 2) {
    return false;
  }

  if (options.max && len > options.max * 2) {
    return false;
  }

  return true;
};

var isTaxCode = function isTaxCode(e) {
  return /^([A-Z0-9]{15,20})$/.test(e) && !/^0+$/.test(e);
};

var isLettersAndNumbers = function isLettersAndNumbers(str) {
  var zg = /^(?!\d+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;

  if (!zg.test(str)) {
    return false;
  } else {
    return true;
  }
};

var isContainsLetterOrNumber = function isContainsLetterOrNumber(str) {
  var zg = /^[0-9a-zA-Z]*$/;

  if (!zg.test(str)) {
    return false;
  } else {
    return true;
  }
};

var _default = {
  isContainsLetterOrNumber: isContainsLetterOrNumber,
  isLettersAndNumbers: isLettersAndNumbers,
  isMobile: isMobile,
  isEmail: isEmail,
  isArea: isArea,
  isNumber: isNumber,
  isBLen: isBLen,
  isTaxCode: isTaxCode
};
exports["default"] = _default;